<template>
  <div class="container">
    <van-form @submit="onSubmit">
      <van-field
        v-model="title"
        label="走访事项"
        placeholder="请输入走访事项"
        maxlength="20"
        required
        :rules="[{ required: true }]"
      />
      <div class="form-item" @click="nameTap">
        <van-field
          v-model="name"
          label="专员姓名"
          required
          placeholder="请输入联系人"
          readonly
        />
        <van-icon name="arrow" v-show="commerId === ''" />
      </div>
      <van-field
        v-model="person"
        label="联系人"
        required
        placeholder="请输入联系人"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="phone"
        label="联系电话"
        required
        placeholder="请输入联系电话"
        :rules="[{ required: true }, { pattern, message: '请填写正确的电话' }]"
      />
      <div class="form-item" @click="dataShow = true">
        <van-field
          v-model="time"
          required
          label="预约时间"
          placeholder="请选择预约时间"
          readonly
          :rules="[{ required: true }]"
        />
        <van-icon name="arrow" />
      </div>
      <van-field
        v-model="message"
        rows="5"
        autosize
        label="描述"
        type="textarea"
        maxlength="300"
        placeholder="请输入描述"
        show-word-limit
      />
      <div class="btn edit-btn" v-if="commerId !== ''">
        <van-button square type="default" native-type="button" @click="cancel"
          >取消</van-button
        >
        <van-button square type="info" native-type="submit">提交</van-button>
      </div>
      <div class="btn" v-else>
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <!-- 联系人选择弹窗 -->
    <van-popup v-model="namePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="nameColumns"
        value-key="name"
        @cancel="namePicker = false"
        @confirm="nameConfirm"
      />
    </van-popup>
    <!-- 时间选择弹窗 -->
    <van-calendar
      v-model="dataShow"
      color="#1989FA"
      :show-confirm="false"
      @select="dataConfirm"
    />
    <van-popup v-model="timePickerStart" round position="bottom">
      <van-datetime-picker
        v-model="timeStartValue"
        type="time"
        title="选择开始时间"
        cancel-button-text="重置"
        @cancel="timeCancel"
        @confirm="timeConfirmStart"
      />
    </van-popup>
    <van-popup v-model="timePickerEnd" round position="bottom">
      <van-datetime-picker
        v-model="timeEndValue"
        type="time"
        title="选择结束时间"
        cancel-button-text="重置"
        @cancel="timeCancel"
        @confirm="timeConfirmEnd"
      />
    </van-popup>
  </div>
</template>
<script>
import { getLocalStorage } from '@utils'
import {
  addVisit,
  visitDetail,
  editVisit
} from '@api/commissioner/commissioner'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      userId: '',
      title: '', // 走访事由
      name: '', // 专员姓名
      person: '', // 联系人
      phone: '', // 联系电话
      time: '', // 预约时间
      message: '', // 描述
      pattern:
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, // 手机号验证
      nameColumns: [], // 专员选项
      namePicker: false, // 专员姓名弹窗
      dataShow: false, // 日期选择弹窗
      dataText: '', // 日期单天
      timePickerStart: false, // 开始时间弹窗
      timePickerEnd: false, // 结束时间弹窗
      timeStartValue: '', // 开始时间
      timeEndValue: '', // 结束时间
      commerId: '',
      disable: false
    }
  },
  mounted() {
    // 专员姓名
    this.userId = this.$route.query.id
    this.commerId = this.$route.query.commerId || ''
    this.nameColumns = JSON.parse(getLocalStorage('userList'))
    this.nameColumns.forEach((item) => {
      if (item.userId == this.userId) {
        this.name = item.name
      }
    })
    // 如果是修改则初始化
    if (this.commerId !== '') {
      this.getBaseInfo()
    }
  },
  methods: {
    // 取消修改跳转回详情页面
    cancel() {
      this.$router.replace({
        path: '/commissioner/details',
        query: {
          id: this.commerId
        }
      })
    },
    getBaseInfo() {
      visitDetail({ id: this.commerId }).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.title = data.commerTitle // 初始化走访事由
          this.name = data.name
          this.person = data.contactPerson
          this.phone = data.contactPhone
          this.dataText = data.startTime.split(' ')[0]
          this.timeStartValue = data.startTime.split(' ')[1]
          this.timeEndValue = data.endTime.split(' ')[1]
          this.time =
            this.dataText +
            ' ' +
            this.timeStartValue +
            ' - ' +
            this.timeEndValue
          this.message = data.notes
        } else {
          Toast(msg)
        }
      })
    },
    onSubmit(values) {
      if (this.disable) return
      this.disable = true
      const api = this.commerId != '' ? editVisit : addVisit
      let params = {
        userId: this.userId,
        commerTitle: this.title,
        contactPerson: this.person,
        contactPhone: this.phone,
        startTime: this.dataText + ' ' + this.timeStartValue,
        endTime: this.dataText + ' ' + this.timeEndValue,
        notes: this.message
      }
      if (this.commerId != '') {
        this.$set(params, 'id', this.commerId)
      }
      api(params)
        .then((res) => {
          const { code, data, msg } = res.data
          if (code == '0000') {
            const msg = this.commerId != '' ? '修改成功' : '提交成功'
            const path =
              this.commerId != ''
                ? '/commissioner/index'
                : '/commissioner/details'
            const query =
              this.commerId != '' ? { id: this.commerId } : { id: data }
            const methods = this.commerId != '' ? 'replace' : 'replace'
            Toast.success({
              message: msg,
              onClose: () => {
                this.disable = false
                this.$router[methods]({
                  path: '/commissioner/details',
                  query: query
                })
              }
            })
          } else {
            if (this.commerId != '') {
              Dialog.alert({
                message: msg
              }).then(() => {
                this.disable = false
                this.$router.push({
                  path: '/commissioner/index',
                  query: {
                    id: this.commerId
                  }
                })
              })
            } else {
              Toast(msg)
              this.disable = false
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.disable = false
        })
    },
    nameTap() {
      if (this.commerId !== '') return
      this.namePicker = true
    },
    nameConfirm(e) {
      this.name = e.name
      this.userId = e.userId
      this.namePicker = false
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    dataConfirm(e) {
      this.time = ''
      this.dataText = this.formatDate(e)
      this.dataShow = false
      this.timePickerStart = true
    },
    timeConfirmStart(e) {
      this.timeStartValue = e
      this.timePickerStart = false
      this.timePickerEnd = true
    },
    timeConfirmEnd(e) {
      this.time = this.dataText + ' ' + this.timeStartValue + ' - ' + e
      this.timeEndValue = e
      this.timePickerEnd = false
    },
    timeCancel() {
      this.dataText = ''
      this.timeStartValue = ''
      this.timeEndValue = ''
      this.dataShow = false
      this.timePickerStart = false
      this.timePickerEnd = false
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  padding-top: 20px;
}
.form-item {
  position: relative;
}
/deep/ .van-icon {
  font-size: 20px;
  position: absolute;
  right: 0;
  z-index: 10;
  top: 10px;
  right: 15px;
}
.btn {
  width: 96%;
  color: #fff;
  background: #0091ff;
  text-align: center;
  border-radius: 6px;
  position: fixed;
  bottom: 20px;
  left: 2%;
  .van-button__content {
    font-size: 16px;
  }
}
.edit-btn {
  background: none;
  display: flex;
  justify-content: space-around;
  /deep/.van-button--default {
    background-color: #eee;
  }
  /deep/.van-button--square {
    width: 40%;
  }
}
</style>
